export enum EBoxType {
  'SUPER',
  'MG',
  'G',
  'P',
}
